import { getDialog } from 'components/dialog-wrapper/use-dialog';
import DialogId from './dialog-id';
import tracking from './tracking';
import useComponentContext from './use-component-context';
import useGotoRecurringPayment from './use-goto-recurring-payment';
import usePaymentDateWithOrdinal from './use-payment-date-with-ordinal';
import useToCurrency from './use-to-currency';

const useDialog = (id: string) => {
  const context = useComponentContext();
  return {
    open: () => context.showDialog(id),
    close: () => context.closeDialog(id),
    exists: () => !!getDialog(id),
  };
}

const closeAllDialogs = () => {
  const dialogs = document.querySelectorAll("#recurring-payment dialog:open");
  dialogs.forEach((dialog) => (dialog as HTMLDialogElement).close());
}

export {
  DialogId,
  closeAllDialogs,
  tracking,
  useComponentContext,
  useDialog,
  useGotoRecurringPayment,
  usePaymentDateWithOrdinal,
  useToCurrency,
}